// trackSearchSuccess
import { getTripleID } from "./common"
const trackSearchSuccess = (keywords, searchNumbers) => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "search_success",
      search_term: keywords,
      search_results: searchNumbers,
      ...getTripleID()
    })
  }
}

const trackSearch = (keywords, redirect) => {
  if (window?.dataLayer) {
    window.dataLayer.push({
      event: "search",
      search_term: keywords,
      eventCallback: function () {
        if (redirect) redirect()
      }
    })
  }
}

export { trackSearchSuccess, trackSearch }
